import { render, staticRenderFns } from "./ReadOnlySupportForm.vue?vue&type=template&id=e7ff9160&"
import script from "./ReadOnlySupportForm.vue?vue&type=script&lang=js&"
export * from "./ReadOnlySupportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports